export const loadWebFonts = () => {
  if (document.getElementById('slide-web-fonts')) {
    return document.fonts ? document.fonts.ready : Promise.resolve();
  }

  const link = document.createElement('link');
  link.id = 'slide-web-fonts';

  link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=Poppins:wght@300;400;500;600;700;800;900&family=Montserrat:wght@300;400;500;600;700;800;900&family=Playfair+Display:wght@300;400;500;600;700;800&family=Orbitron:wght@400;500;600;700;800;900&family=Rajdhani:wght@300;400;500;600;700&family=Caveat:wght@500;600;700&family=Kalam:wght@400;700&family=Shadows+Into+Light&family=Patrick+Hand&display=swap';
  link.rel = 'stylesheet';
  
  return new Promise((resolve) => {
    link.onload = () => {
      if (document.fonts) {
        document.fonts.ready.then(() => {
          setTimeout(() => {
            resolve();
          }, 500);
        });
      } else {
        setTimeout(() => {
          resolve();
        }, 1500);
      }
    };
    
    link.onerror = () => {
      resolve();
    };
    
    document.head.appendChild(link);
  });
};